/**
 * Plan & Usage — colors from product design that are not yet on the MUI palette.
 * Prefer `theme.palette.*` in components where values match (e.g. heat empty ≈ background.default).
 */
export const PLAN_USAGE = {
  heatMapSurface: '#F5F5F5',
  heatEmpty: '#EBEBEB',
  heatLow: '#C5ECB2',
  heatMid: '#56C364',
  heatHigh: '#11865B',
  actionOutlineBorder: '#E0E0E0',
  progressFill: '#3F801C',
  monthAxis: 'var(--app-text-tertiary)',
  weekdayAxis: 'var(--app-text-tertiary)',
  footerMuted: 'var(--app-text-tertiary)',
}
